import { classList } from "../../../lib";
import "./Hr.scss"

export default function Hr({ className = "", height=1 }: { className?: string, height?: number|string }) {
    return <div className={classList({
        [className]: true,
        hr: true
    })} style={{ height }} />
}